export default "__VITE_ASSET__BPdim2e0__"